import Request from './request'

const DeviceLog = {
  saveDeviceLogs (fid, params, callback, bad_answer) {
    Request.get('device-log/as-file/' + fid, params).then(callback).catch(bad_answer)
  },
  getDeviceLog(fid, params, callback) {
    Request.post('device-log/internal-log/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default DeviceLog
